import { ScoopDatePicker, ScoopSelector } from '../../../../../ui'
import styles from './ConfigurationSummary.module.scss'

/**
 * Displays a summary of the connector configuration
 * Shows the object selection, fields, filters, date range, and AI reasoning
 */
export const ConfigurationSummary = ({
    objectLabel,
    fieldLabels = [],
    filters = [],
    requireDateRange,
    startDate,
    onStartDateChange,
    requireObjectSelection = false,
    objectList = [],
    objectSelectionLabel = 'Property',
    selectedObjectName,
    onObjectChange,
    reasoning,
}) => {
    // For connectors like GA4 the "object" is the Property the user extracts
    // from. With a single option it is auto-selected upstream and shown
    // read-only; with several the user picks one.
    const renderObjectSelection = () => {
        if (!requireObjectSelection) return null

        if (objectList.length === 1) {
            return (
                <div className={styles.section}>
                    <span className={styles.label}>{objectSelectionLabel}:</span>
                    <span className={styles.value}>{objectList[0].label}</span>
                </div>
            )
        }

        return (
            <div className={styles.section}>
                <span className={styles.label}>{objectSelectionLabel}:</span>
                <ScoopSelector
                    value={selectedObjectName || ''}
                    onChange={(e) => onObjectChange(e.target.value)}
                    options={objectList.map((obj) => ({
                        label: obj.label,
                        value: obj.name,
                    }))}
                    placeholder={`Select a ${objectSelectionLabel}`}
                    searchable={objectList.length > 6}
                />
            </div>
        )
    }

    return (
        <div className={styles.container}>
            {/* When the connector exposes a real object list, the picked object
                replaces the preset's placeholder — showing both would just be
                a confusing, meaningless "Object:" row. */}
            {requireObjectSelection ? (
                renderObjectSelection()
            ) : (
                <div className={styles.section}>
                    <span className={styles.label}>Object:</span>
                    <span className={styles.value}>{objectLabel}</span>
                </div>
            )}

            <div className={styles.section}>
                <span className={styles.label}>Fields ({fieldLabels.length}):</span>
                <ul className={styles.fieldList}>
                    {fieldLabels.map((field, index) => (
                        <li key={index} className={styles.fieldItem}>
                            {field}
                        </li>
                    ))}
                </ul>
            </div>

            {filters.length > 0 && (
                <div className={styles.section}>
                    <span className={styles.label}>Filters:</span>
                    <ul className={styles.fieldList}>
                        {filters.map((filter, index) => (
                            <li key={index} className={styles.fieldItem}>
                                {filter.displayText}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {requireDateRange && (
                <div className={styles.section}>
                    <span className={styles.label}>Start Date:</span>
                    <ScoopDatePicker value={startDate} range={false} onChange={onStartDateChange} />
                </div>
            )}

            {reasoning && <p className={styles.reasoning}>{reasoning}</p>}
        </div>
    )
}
